import { useSyncExternalStore } from "react";

import { auth, type Session } from "./auth";

/** The signed-in session; screens behind the sign-in gate only. */
export function useSession(): Session {
  const state = useSyncExternalStore(auth.subscribe, auth.get);
  if (state.status !== "signed_in") throw new Error("not signed in");
  return state.session;
}

export function useOwner(): { org_id: string; user_id: string } {
  const s = useSession();
  return { org_id: s.active_org_id ?? "", user_id: s.user.id };
}
